import PropTypes from 'prop-types';
import { Inline, Stack, Text, textVariants } from '@etg/wings';
import { Icon } from '@eti/components';
import { useProperty, useSiteContext, useTranslation } from '@eti/providers';
import { css } from '@eti/styles';
import { SELF_TRANSFER } from '../../../../constants/eventSegmentTypes';
import { getLocalizedDuration } from '../../../../widgets/trip-details/utils/format';
import { eventSegmentTitlesKeys } from '../../../../utils/format';
import SelfTransferText from './SelfTransferText';

const eventSegmentLabelStyles = css`
  font-weight: 700;
`;

const selfTransferStyles = css`
  color: #0f7012;
`;

const selfTransferListStyles = css`
  padding-inline-start: 32px;
`;

const eventSegmentStyles = css`
  padding-inline-start: 16px;
`;

const filterOutSelfTransfer = (types) => types.filter(({ type }) => type !== SELF_TRANSFER);
const isSelfTransfer = (types) => types.some(({ type }) => type === SELF_TRANSFER);

const ReviewTripDetailsEventSegment = ({ boundNumber, duration, index, types }) => {
  const { t } = useTranslation();
  const { p } = useProperty();
  const { language, timeFormat } = useSiteContext();

  const eventSegmentTitles = Object.fromEntries(
    Object.entries(eventSegmentTitlesKeys).map(([key, value]) => [key, t(value)]),
  );

  return (
    <Stack className={eventSegmentStyles} spacing={4}>
      {isSelfTransfer(types) && (
        <div
          data-testid={`travelerDetails-reviewModal-flightInformation-bound-${boundNumber}-eventSegment-${
            index + 1
          }`}
        >
          <Stack spacing={4}>
            <Inline alignY="center" className={selfTransferStyles} spacing={4}>
              <Icon color="currentColor" id="self-transfer" size="0.75rem" />
              <Text as="span" asHtml variant={textVariants._14_BOLD}>
                {t('SelfTransfer.Result.Header.Text')}
              </Text>
            </Inline>
            <Stack as="ul" className={selfTransferListStyles} spacing={4}>
              {p('SelfTransfer.IconsAndText.Baggage.Enabled') && (
                <SelfTransferText text="SelfTransfer.Result.Baggage.Text" />
              )}
              {p('SelfTransfer.IconsAndText.Transfer.Enabled') && (
                <SelfTransferText text="SelfTransfer.Result.Transfer.Text" />
              )}
              {p('SelfTransfer.IconsAndText.Guarantee.Enabled') && (
                <SelfTransferText text="SelfTransfer.Result.Guarantee.Text" />
              )}
            </Stack>
          </Stack>
        </div>
      )}
      {filterOutSelfTransfer(types).map(({ legendNumber, type }, eventIndex) => (
        <span
          className={eventSegmentLabelStyles}
          data-testid={`travelerDetails-reviewModal-flightInformation-bound-${boundNumber}-eventSegment-${
            eventIndex + 1
          }`}
          key={`eventSegment-${legendNumber}-${type}`}
        >
          {eventSegmentTitles[type]}: {getLocalizedDuration(duration, language.code, timeFormat)}
        </span>
      ))}
    </Stack>
  );
};

ReviewTripDetailsEventSegment.propTypes = {
  boundNumber: PropTypes.number,
  duration: PropTypes.number,
  index: PropTypes.number,
  types: PropTypes.arrayOf(
    PropTypes.shape({
      legendNumber: PropTypes.number,
      type: PropTypes.string,
    }),
  ),
};

export default ReviewTripDetailsEventSegment;
